import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import MainSidebar from '../../components/MainSidebar'
import MainHeaderBar from '../../components/MainHeaderBar'
import { inject, observer } from 'mobx-react'
import SuperAdminPageSidebar from '../../components/SuperAdminPageSidebar'
import SidebarCollapseToggle from '../SidebarCollapseToggle'
import styles from './DashboardLayout.module.css'
import { useHistory, useLocation } from 'react-router-dom'

const STORAGE_KEY = 'isCollapsedSidebar'

const DashboardLayout = ({ ...props }) => {
  const { children, title, commonStore, backgroundColor } = props

  const history = useHistory()
  const location = useLocation()

  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : false
    } catch {
      return false
    }
  })
  const navigationMenuClassName = useMemo(
    () =>
      `${styles.navigationMenu} ${
        isCollapsed ? styles.navigationMenuCollapsed : ''
      }`,
    [isCollapsed]
  )
  const logoSrc = useMemo(
    () => `${process.env.PUBLIC_URL}/assets/photos/portal_logo_white.png`,
    []
  )
  const logoWidth = useMemo(() => (isCollapsed ? 40 : 99), [isCollapsed])
  const contentStyle = useMemo(
    () => ({ backgroundColor: backgroundColor || '#fff' }),
    [backgroundColor]
  )

  useEffect(() => {
    commonStore.setCollapsedMenu(!isCollapsed)
  }, [commonStore, isCollapsed])

  useEffect(() => {
    const currentPath = location.pathname

    if (
      currentPath !== '/report' &&
      currentPath !== '/report/periodic' &&
      currentPath !== '/report/extraordinary'
    ) {
      sessionStorage.removeItem('selectedYear')
    }

    window.scrollTo(0, 0)
    const scrollContainer =
      document.querySelector(`.${styles.mainContentWrapper}`) ||
      document.querySelector('.mainContentWrapper')
    if (scrollContainer) {
      scrollContainer.scrollTop = 0
    }
  }, [location.pathname])

  const handleCollapseChange = useCallback(
    next => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
      setIsCollapsed(next)
      commonStore.setCollapsedMenu(!next)
    },
    [commonStore]
  )

  const goToDashboard = useCallback(() => {
    history.push('/dashboard')
  }, [history])

  return (
    <>
      <div className={styles.mainLayoutWrapper}>
        <aside className={navigationMenuClassName}>
          <figure
            className="logoWrapper"
            onClick={goToDashboard}>
            <img
              src={logoSrc}
              alt="VIMC logo"
              width={logoWidth}
            />
          </figure>

          <nav role="navigation">
            <div>
              {props.isSuperAdminPage ? (
                <SuperAdminPageSidebar collapsedMenu={!isCollapsed} />
              ) : (
                <MainSidebar collapsedMenu={!isCollapsed} />
              )}
            </div>
          </nav>

          <SidebarCollapseToggle
            isCollapsed={isCollapsed}
            onChange={handleCollapseChange}
          />
        </aside>

        <div className={styles.mainContentWrapper}>
          <header className="navigationTabBar">
            <MainHeaderBar title={title} />
          </header>
          <div
            className="contentContainer"
            style={contentStyle}>
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

DashboardLayout.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  commonStore: PropTypes.object,
  isSuperAdminPage: PropTypes.bool,
  title: PropTypes.string,
}

export default memo(inject('commonStore')(observer(DashboardLayout)))
